import { all, call, put, select, takeLatest } from "typed-redux-saga";
import { log } from "react-better-html";

import { LocalStorage } from "../../utils/localStorage";

import { appSlice } from "../slices/app";
import { userSlice } from "../slices/user";
import { organizationsSlice } from "../slices/organizations";
import { workspacesSlice } from "../slices/workspaces";

import { type RootState } from "../store";

function* onLoadApp() {
   log.info("App started loading");

   yield* call(onLoadUserUnrelatedData);
   yield* put(appSlice.actions.loadUserRelatedData());

   log.info("App loaded");
}

function* onLoadUserUnrelatedData() {
   const cachedFirebaseUser = yield* call(() => LocalStorage.getItem("firebaseUser"));
   const cachedUser = yield* call(() => LocalStorage.getItem("user"));
   const cachedOrganizations = yield* call(() => LocalStorage.getItem("organizations"));
   const cachedSelectedOrganizationId = yield* call(() => LocalStorage.getItem("selectedOrganizationId"));
   const cachedWorkspaces = yield* call(() => LocalStorage.getItem("workspaces"));

   if (cachedFirebaseUser) yield* put(userSlice.actions.setFirebaseUser(cachedFirebaseUser));
   if (cachedUser) yield* put(userSlice.actions.setUser(cachedUser));
   if (cachedOrganizations) yield* put(organizationsSlice.actions.setOrganizations(cachedOrganizations));
   if (cachedSelectedOrganizationId)
      yield* put(
         organizationsSlice.actions.setSelectedOrganizationId({
            organizationId: cachedSelectedOrganizationId,
         }),
      );
   if (cachedWorkspaces) yield* put(workspacesSlice.actions.setWorkspaces(cachedWorkspaces));

   log.success("Cache loaded");
}

function* onLoadUserRelatedData() {
   const user = yield* select((state: RootState) => state.user.user);
   const userLoaded = yield* select((state: RootState) => state.user.userLoaded);

   if (!user || !userLoaded) return;

   yield* put(organizationsSlice.actions.getAllOrganizations());

   log.success("User data loaded");
}

export default function* appSagas() {
   yield* all([
      takeLatest(appSlice.actions.loadApp, onLoadApp),
      takeLatest(appSlice.actions.loadUserRelatedData, onLoadUserRelatedData),
   ]);
}
